/* lua.js generated code 0.3.0 */

PushBounceIdleBubbleAnim = xClass("PushBounceIdleBubbleAnim")
// scaleType 2 : 攻略结束后的退出按钮动画用
PushBounceIdleBubbleAnim.prototype.ctor = function (button, scaleType = 1) {
    if (button == null){
        var scene = cc.Director.getInstance().getRunningScene();
        if (window.logCenter) {
            var msg = {
                message: "PushBounceIdleBubbleAnim button null, scene name" + scene.name
            }
            window.logCenter.log(msg);
        }
        return;
    }
    var self = this
    self.downHandler = null
    self.moveInHandler = null
    self.moveOutHandler = null
    self.upHandler = null
    self.upOutHandler = null
    self.button = button
    self.scaleX = self.button.getScaleX()
    self.scaleY = self.button.getScaleY()
    self.animValid = true
    self.scaleType = scaleType;
    self.useAnim()
}
PushBounceIdleBubbleAnim.prototype.useAnim = function () {
    var self = this
    var listening = false
    self.animValid = true
    function onBounceEnable() {
        if (listening) {
            return 
        }
        listening = true
        self.button.stopAction(self.action)
        self.action = null
        if (!self.animValid) {
            return 
        }
        self.button.runAction(cc.ScaleTo.create(0.05, 0.85 * self.scaleX, 0.85 * self.scaleY))
    }
    function onBounceDisable() {
        if (!listening) {
            return 
        }
        listening = false
        if (self.action) {
            self.button.stopAction(self.action)
        }
        if (!self.animValid) {
            return 
        }
        self.action = cc.Sequence.create(cc.ScaleTo.create(0.1, self.scaleX * 1.1, self.scaleY * 1.1), cc.ScaleTo.create(0.08, self.scaleX, self.scaleY), cc.CallFunc.create(function () {
            var action1 = cc.ScaleBy.create(1, 0.95, 1.05)
            var action2 = cc.ScaleBy.create(1, 1 / 0.95, 1 / 1.05)
            self.action = cc.RepeatForever.create(cc.Sequence.create(action1, action2, action2.clone(), action1.clone()))
            self.button.runAction(self.action)
        }))
        self.button.runAction(self.action)
    }
    var useless
    [useless, self.downHandler] = self.button.on(UIButtonEvent.Down, onBounceEnable)
    [useless, self.moveInHandler] = self.button.on(UIButtonEvent.MoveIn, onBounceEnable)
    [useless, self.upHandler] = self.button.on(UIButtonEvent.Click, onBounceDisable)
    [useless, self.moveOutHandler] = self.button.on(UIButtonEvent.MoveOut, onBounceDisable)
    [useless, self.upOutHandler] = self.button.on(UIButtonEvent.UpOutside, onBounceDisable)
    if (self.scaleType == 1){
        var action1 = cc.ScaleBy.create(1, 0.95, 1.05)
        var action2 = cc.ScaleBy.create(1, 1 / 0.95, 1 / 1.05)
        self.action = cc.RepeatForever.create(cc.Sequence.create(action1, action2, action2.clone(), action1.clone()))
        self.button.runAction(self.action)
    }else if (self.scaleType == 2){
        var action1 = cc.ScaleBy.create(0.5, 0.9, 1.1)
        var action2 = cc.ScaleBy.create(0.5, 1 / 0.9, 1 / 1.1)
        var action3 = cc.ScaleBy.create(0.25, 0.9, 1.1)
        var action4 = cc.ScaleBy.create(0.25, 1 / 0.9, 1 / 1.1)
        self.action = cc.RepeatForever.create(cc.Sequence.create(action1, action2, action3, action4));
        self.button.runAction(self.action)
    }
}
PushBounceIdleBubbleAnim.prototype.removeAnim = function () {
    var self = this
    if (self.action) {
        self.button.stopAction(self.action)
        self.animValid = false
        self.action = null
    }
    self.button.setScaleX(self.scaleX)
    self.button.setScaleY(self.scaleY)
    self.button.removeEventListener(self.downHandler)
    self.button.removeEventListener(self.moveInHandler)
    self.button.removeEventListener(self.moveOutHandler)
    self.button.removeEventListener(self.upHandler)
    self.button.removeEventListener(self.upOutHandler)
}
module.exports = PushBounceIdleBubbleAnim
